import { Episode } from "./episode";

export class Season {
    id: number = 0;
    name: string = '';
    episodes: Episode[] = [];
    seasonNumber: number = 0;
    airDateStart: Date = new Date();
    airDateEnd: Date = new Date();
    createdAt: Date = new Date();
    updatedAt: Date = new Date();
    expandDetails: boolean = false;

    static mapProperties(item: any): Season {
        return {
            id: item.id,
            name: item.name?.replace(/ {2,}/g, ' '),
            seasonNumber: item.season_number,
            airDateStart: item.air_date_start,
            airDateEnd: item.air_date_end,
            createdAt: item.created_at,
            updatedAt: item.updated_at,
            episodes: item.episodes.map((episode: any) => Episode.mapProperties(episode)),
            expandDetails: false
        };
    }
}
